<ng-container *ngIf="representative$ | async as representative; else noRepresentative">
  <div class="representative">
    <div class="representative-photo">
      <img *ngIf="image; else placeholderImage" class="representative-image" [src]="image" (error)="onImageError()" alt="" />
      <ng-template #placeholderImage>
        <img
          *ngIf="worksheetImage$ | async as worksheetImage; else defaultPlaceholder"
          class="representative-image"
          [src]="worksheetImage | contentImage : '6' : 'marketplace'"
          alt=""
        />
        <ng-template #defaultPlaceholder>
          <img class="representative-image" [src]="'placeholders/person.png' | contentAssetImage" alt="" />
        </ng-template>
      </ng-template>
    </div>
    <div class="representative-details">
      <div class="representative-heading">
        <h4 class="representative-name">{{ representative.Name }}</h4>
        <div class="representative-job">{{ representative.JobTitle }}</div>
      </div>
      <div class="representative-contact">
        <div class="representative-field">
          <span class="material-icons">mail</span>
          <span class="representative-field-text">{{ representative.EmailAddress }}</span>
        </div>
        <div class="representative-field">
          <span class="material-icons">call</span>
          <span class="representative-field-text">{{ representative.PhoneNumber }}</span>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #noRepresentative>
  <div class="representative-empty">
    <img class="representative-empty-image" [src]="'placeholders/pick-a-player.svg' | contentAssetImage" alt="" />
    {{ 'account.representative.empty' | translate : { fgbdefault: 'No representative has been assigned to your account yet.' } }}
  </div>
</ng-template>
